<script>
import _ from 'lodash';
import VueRouter from 'vue-router';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
  name: 'Wizard',
  data() {
    return {
      currentPage: null,
    };
  },
  watch: {
    $route(to) {
      this.setCurrentPage(to);
    },
  },
  methods: {
    setCurrentPage(route) {
      const currentPage = this.getPageFromRoute(route);
      if (currentPage) {
        this.currentPage = currentPage;
      } else {
        throw new Error(`Couldn't extract current page from route: ${route.fullPath}`);
      }
    },
    getPageFromRoute(route) {
      const pathSegments = route.fullPath.split('/');
      return _.last(pathSegments);
    },
    isRootPath(route, basePath) {
      return route.fullPath.endsWith(basePath) || route.fullPath.endsWith(`${basePath}/`);
    },
    async navigateToFirstPage(basePath, firstPage) {
      if (this.isRootPath(this.$router.currentRoute, basePath)) {
        try {
          await this.$router.replace(`${this.$router.currentRoute.fullPath}/${firstPage}`);
        } catch (failure) {
          if (!isNavigationFailure(failure, NavigationFailureType.duplicated)) {
            throw failure;
          }
        }
      }
    },
    validatePage(currentPageRef) {
      if (currentPageRef.validate && typeof currentPageRef.validate === 'function') {
        return currentPageRef.validate();
      }
      return true;
    },
    async goToNextPage(currentPageRef, allPages) {
      if (this.validatePage(currentPageRef)) {
        const currentPageIndex = _.findIndex(allPages, p => p === this.currentPage);
        if (currentPageIndex === allPages.length - 1) {
          this.$emit('wizard-completed');
        } else {
          const nextPage = allPages[currentPageIndex + 1];
          await this.$router.push(nextPage);
        }
      }
    },
  },
};
</script>
